import { render } from "./SettingsModule.vue?vue&type=template&id=0dd90ce2&scoped=true"
import script from "./SettingsModule.vue?vue&type=script&lang=js"
export * from "./SettingsModule.vue?vue&type=script&lang=js"

import "./SettingsModule.vue?vue&type=style&index=0&id=0dd90ce2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dd90ce2"

export default script